import React from 'react';
import Button from 'components/button/button';
import Icon from 'components/icon/icon';

type GoToTopCtaPropsType = {
    onClick?: () => void;
};
const GoToTopCta: React.FC<GoToTopCtaPropsType> = (props) => (
    <Button
        icon={<Icon size="md" name={Icon.Name.ChevronUp} />}
        onClick={props.onClick}
        isCircle={true}
        designType={Button.designType.STROKE}
    />
);

export default GoToTopCta;
